import DebtReportList from "./DebtReportList";
import { Grid, Stack } from "@mui/material";
import DebtReportFileList from "./DebtReportFileList";

const DebtReportPage = () => {
  return (
    <Stack overflow="auto">
      <Grid
        container
        spacing={2}
        px={1}
        py={2}
      >
        <Grid
          item
          xs={12}
          lg={6}
        >
          <DebtReportList />
        </Grid>
        <Grid
          item
          xs={12}
          lg={6}
        >
          <DebtReportFileList />
        </Grid>
      </Grid>
    </Stack>
  );
};

export { DebtReportPage };
